<template>
    <div v-bind:class="classes" @click="onSwitchItem" role="button" tabindex="0" :aria-label="item.title">
        <div v-bind:class="iconClasses"></div>
        <div class="top-level-menu-item-title ellipsis">{{item.title}}</div>
        <div v-bind:class="indicatorClasses">{{item.indicatorText}}</div>
    </div>
</template>

<script>

    export default {
        name: "top-level-menu-item-view",
        props: {
            item: {
                type: Object
            }
        },
        computed: {
            indicatorClasses() {
                const indicatorClass = this.item.indicatorClass || '';
                return {
                    'top-level-menu-item-indicator': true,
                    [indicatorClass]: true
                }
            },
            iconClasses() {
                return {
                    'top-level-menu-item-icon': true,
                    [`ico-${this.item.iconClass}`]: true
                }
            },
            classes() {
                return {
                    'top-level-menu-item': true,
                    enabled: this.item.enabled
                }
            }
        },
        methods: {
            onSwitchItem(event) {
                event.stopPropagation();
                if (this.item.openInNewTab) {
                    window.LE.navigator.open(this.item.switcherRoute, 'service_status_dashboard');
                }
                else {
                    this.$router.push(this.item.switcherRoute);
                }
                this.$emit("clicked");
            },
        }
    }
</script>

<style scoped>

</style>
